import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LogoutIcon from '@mui/icons-material/Logout';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { Alert, AlertColor, AppBar, IconButton, Slide, SlideProps, Toolbar } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import { createTheme, CSSObject, styled, Theme, ThemeProvider, useTheme } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import i18n from '../i18n';
import { ApplicationState } from '../store';
import Modal from './common/Modal';
import Helpers from './helpers/Helpers';
import Participants from './Participants';
import ScheduleMeeting from './ScheduleZoomMeeting';


const drawerWidth = 240;
const StyledSnackbar = styled(Snackbar)(({ theme: Theme }) => ({
    "& MuiSnackbar-root": {
        //   top: theme.spacing(15),
        //   left: theme.spacing(15),
    },
}));
const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    height: 'auto',
    // width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        //width: `calc(${theme.spacing(8)} + 1px)`,
    },
});
function SlideTransition(props: SlideProps) {
    return <Slide {...props} direction="down" />;
}
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    height: 'auto',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));


const themePaper = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    top: '-3px !important'
                }
            },
        }
    }
});
const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop: any) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        //...(open && {
        //    ...openedMixin(theme),
        //    '& .MuiDrawer-paper': openedMixin(theme),
        //}),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
        // marginRight: 0,
    }),
);
interface ILayoutProps {
    children?: any;
}
const Layout = (props: ILayoutProps) => {
    const userData = useSelector((state: ApplicationState) => state.appData);
    const appLanguage = useSelector((state: ApplicationState) => state.appData?.app4legalData?.lang);
    const direction = appLanguage == "ar" ? "rtl" : "ltr";
    const [url, setUrl] = React.useState<string>("https://docs.lexzur.com/sharepoint"); //documents // onedrive // sharepoint // gdrive // dropbox
    const [selectedItems, setSelectedItems] = React.useState<any[]>([]);
    const [anchorElInfo, setAnchorElInfo] = React.useState<HTMLButtonElement | null>(null);
    const [anchorElLogout, setAnchorElLogout] = React.useState<HTMLButtonElement | null>(null);
    const [anchorElScheduleMeeting, setAnchorElScheduleMeeting] = React.useState<HTMLButtonElement | null>(null);
    const [anchorElParticipants, setAnchorElParticipants] = React.useState<HTMLButtonElement | null>(null);
    const [anchorElDocs, setAnchorElDocs] = React.useState<HTMLButtonElement | null>(null);
    const [participantsSeverity, setParticipantsSeverity] = React.useState<AlertColor | undefined>("success");
    const [participantsOpen, setParticipantsOpen] = React.useState(false);
    const [participantsAlertContent, setParticipantsAlertContent] = React.useState("");
    const [scheduleSeverity, setscheduleSeverity] = React.useState<AlertColor | undefined>("success");
    const [scheduleOpen, setScheduleOpen] = React.useState(false);
    const [schedulealertContent, setScheduleAlertContent] = React.useState("");
    const openPopOver = Boolean(anchorElInfo);
    const openPopOverScheduleMeeting = Boolean(anchorElScheduleMeeting);
    const openPopOverParticipants = Boolean(anchorElParticipants);
    const openPopOverDocs = Boolean(anchorElDocs);
    const idMeetingInfo = openPopOver ? 'meeting-info' : undefined;
    const idMeetingParticipants = openPopOver ? 'meeting-participants' : undefined;
    const idMeetingDocs = openPopOver ? 'meeting-Docs' : undefined;
    const idScheduleMeeting = openPopOverScheduleMeeting ? 'schedule-meeting' : undefined;
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [openn, setOpenn] = React.useState(true);
    const [inviteesList, setInviteesList] = React.useState<any[]>([]);
    const [anchorEl, setAnchorEl] = React.useState(false);
    const isMenuOpen = Boolean(false);
    React.useEffect(() => {
        if (openPopOverDocs == true) {
            setTimeout(handleActionAfterOpenDocs
                , 3000);
        }
    }, [openPopOverDocs]);
    const navigate = useNavigate();
    const handleActionAfterOpenDocs = () => {
        let apiKey = userData?.app4legalData["x-api-key"];
        let jsonObj = {
            "x-api-key": apiKey,
            "api-base-url": userData?.app4legalData["api-base-url"] ?? "https://app4legaladd.azurewebsites.net/",
            "lang": "english",
            "module": 'docs'
        }
        let iframeEl = document.getElementById('attachDocsIframe') as HTMLIFrameElement;
        if (iframeEl != null) {
            iframeEl.onload = function () {
                iframeEl!.contentWindow!.postMessage({ payload: jsonObj }, "*");
            };
            iframeEl!.contentWindow!.postMessage({ payload: jsonObj }, "*");
        }

    };
    const toggleDrawer = (newOpen: boolean) => () => {
        if (userData?.tokens)
            setOpenn(newOpen);
    };
    React.useEffect(() => {
        //console.log(userData);
        if (!userData?.tokens)
            setOpenn(false);
        else
            setOpenn(true);
        if (userData?.app4legalData?.module == null) {
            if (userData?.contractData!=null)
                setInviteesList(userData?.contractData?.InviteesList);
        }
        if (userData?.app4legalData?.module) {
            switch (userData?.app4legalData["module"]!) {
                case "matter": {
                    if (userData?.matterData != null)
                        setInviteesList(userData?.matterData?.InviteesList);
                    break;
                }
                case "contract": {
                    if (userData?.contractData != null)
                        setInviteesList(userData?.contractData?.InviteesList);
                    break;
                }
                default: {
                    break
                }
            }
        }

    }, [userData]);
    const drawerBleeding = 0;
    const handleParticipantsAlertClose = () => {
        setParticipantsOpen(false);
    };
    const handleScheduleAlertClose = () => {
        setScheduleOpen(false);
    };
    const handleClose = () => {
        setAnchorEl(false);
    };
    const handleParticipantsClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorElParticipants(event.currentTarget);
    };
    const handleScheduleAMeetingClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorElScheduleMeeting(event.currentTarget);
    };
    const handleMeetingInfoClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorElInfo(event.currentTarget);
    };
    const handleLogoutClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        navigate("end");
    };
    const handleInfoClose = () => {
        setAnchorElInfo(null);
    };
    const handleDocsClose = () => {
        setAnchorElDocs(null);
    };
    const handleScheduleAMeetingClose = () => {
        setAnchorElScheduleMeeting(null);
    };
    const handleParticipantsClose = () => {
        setAnchorElParticipants(null);
    };
    const handleParticipantsClosee = (severity: any, content: any) => {
        // setParticipantsSeverity(severity);
        //    setParticipantsAlertContent(content);
        if (severity == "success")
            setAnchorElParticipants(null);
        else {
            setParticipantsOpen(true);
             setParticipantsSeverity(severity);
             setParticipantsAlertContent(content);
        }
        //   setParticipantsOpen(true);

    };
    const handleScheduleClosee = (severity: any, content: any) => {
        //  setscheduleSeverity(severity);
        //  setScheduleAlertContent(content);
        if (severity == "success")
            setAnchorElScheduleMeeting(null);
        else {
            setScheduleOpen(true);
            setscheduleSeverity(severity);
            setScheduleAlertContent(content);
        }
        //  setScheduleOpen(true);

    };
    return (<Box sx={{ display: 'flex' }}>
        <Modal />
        <StyledSnackbar
            open={participantsOpen}
            autoHideDuration={4000}
            onClose={handleParticipantsAlertClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            TransitionComponent={SlideTransition}
        >

            <Alert severity={participantsSeverity}>{participantsAlertContent}</Alert>
        </StyledSnackbar>
        <StyledSnackbar
            open={scheduleOpen}
            autoHideDuration={4000}
            onClose={handleScheduleAlertClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            TransitionComponent={SlideTransition}
        >
            <Alert severity={scheduleSeverity}>{schedulealertContent}</Alert>
        </StyledSnackbar>
        <CssBaseline />
        <Drawer variant="permanent" open={openn} anchor="right">
            <Divider />
            <IconButton onClick={toggleDrawer(true)}>
                {appLanguage == "ar" ?
                    <ChevronRightIcon ></ChevronRightIcon>
                    :
                    <ChevronLeftIcon ></ChevronLeftIcon>
                }
            </IconButton>
            <SwipeableDrawer
                anchor="right"
                open={openn}
                hideBackdrop={true}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                swipeAreaWidth={drawerBleeding}
                variant="persistent"

                disableSwipeToOpen={false}
                ModalProps={{
                    keepMounted: true,
                }}
            >
                <IconButton onClick={toggleDrawer(false)}>
                    {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                </IconButton>
                <Divider />
                <List>
                    <ListItem key={"Info"} alignItems="center" disablePadding sx={{ display: 'block' }}>
                        <ListItemButton
                            key={0}
                            onClick={(event: any) => {
                                handleMeetingInfoClick(event)
                            }}
                            sx={{
                                minHeight: 48,
                                width: '100%',
                                justifyContent: open ? 'center' : 'center',
                                display: open ? 'flex' : 'inline-grid',
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : 0,
                                    justifyContent: 'center',
                                }}
                            >
                                <HelpOutlineIcon />
                            </ListItemIcon>
                            <ListItemText secondary={i18n.t('app.meetingInfo')} sx={{ opacity: open ? 1 : 1, textAlign: open ? 'inherit' : 'center' }} />
                        </ListItemButton>

                    </ListItem>

                    <ListItem key={"Participants"} alignItems="center" disablePadding sx={{ display: 'block' }}>
                        <ListItemButton
                            key={1}
                            onClick={(event: any) => {
                                handleParticipantsClick(event)
                            }}
                            dense
                            sx={{
                                minHeight: 48,
                                width: '100%',
                                justifyContent: open ? 'center' : 'center',
                                display: open ? 'flex' : 'inline-grid',
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : 0,
                                    justifyContent: 'center',
                                }}
                            >
                                <PeopleOutlineIcon />
                            </ListItemIcon>
                            <ListItemText secondary={i18n.t('app.participants')} sx={{ opacity: open ? 1 : 1, textAlign: open ? 'inherit' : 'center' }} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"ScheduleMeeting"} alignItems="center" disablePadding sx={{ display: 'block' }}>
                        <ListItemButton
                            key={1}
                            onClick={(event: any) => {
                                handleScheduleAMeetingClick(event)
                            }}
                            dense
                            sx={{
                                minHeight: 48,
                                width: '100%',
                                justifyContent: open ? 'center' : 'center',
                                display: open ? 'flex' : 'inline-grid',
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : 0,
                                    justifyContent: 'center',
                                }}
                            >
                                <CalendarMonthIcon />
                            </ListItemIcon>
                            <ListItemText secondary={i18n.t('app.scheduleMeeting')} sx={{ opacity: open ? 1 : 1, textAlign: open ? 'inherit' : 'center' }} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={"Logout"} alignItems="center" disablePadding sx={{ display: 'block' }}>
                        <ListItemButton
                            key={0}
                            onClick={
                                (event) => {
                                    //revoke access token
                                    Helpers.revokeZoomToken({ "tokens": userData?.tokens });
                                    Helpers.deleteZoomTokens();
                                    navigate("log_out");
                                    if (window.location.pathname != "/end") {
                                        Helpers.deleteZoomTokens();
                                        setTimeout(() => { window.location.reload() }, 2000);
                                    }
                                    handleClose();
                                }}
                            sx={{
                                minHeight: 48,
                                width: '100%',
                                justifyContent: open ? 'center' : 'center',
                                display: open ? 'flex' : 'inline-grid',
                                px: 2.5,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 3 : 0,
                                    justifyContent: 'center',
                                }}
                            >
                                <LogoutIcon />
                            </ListItemIcon>
                            <ListItemText secondary={i18n.t('app.logout')} sx={{ opacity: open ? 1 : 1, textAlign: open ? 'inherit' : 'center' }} />
                        </ListItemButton>
                    </ListItem>
                </List>
            </SwipeableDrawer>
            <Divider />
        </Drawer>
        <ThemeProvider theme={themePaper}>
            <Popover
                style={{
                    //  height: '100vh',
                    top: '0 !important',
                    // minHeight: '100%',
                    maxHeight: '100%',
                    border: '1px solid #ccc',
                    paddingTop: '20px',
                }}
                id={idMeetingParticipants}
                open={openPopOverParticipants}
                anchorEl={anchorElParticipants}
                onClose={handleParticipantsClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: direction == "rtl" ? 'right' : 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: direction == "rtl" ? 'left' : 'right',
                }}

            >
                <Participants inviteesList={inviteesList} view={false} handleParticipantsClosee={handleParticipantsClosee} />

            </Popover>

            <Popover
                style={{
                    height: '100vh',
                    top: '0 !important',
                    maxHeight: '100%',
                    border: '1px solid #ccc',
                    paddingTop: '0px',
                    paddingBottom: '0px'
                }}
                id={idMeetingInfo}
                open={openPopOver}
                anchorEl={anchorElInfo}
                onClose={handleInfoClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: direction == "rtl" ? 'right' : 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: direction == "rtl" ? 'left' : 'right',
                }}

            >
                <Paper >
                    <ZoomMeetingDetails />
                </Paper>
            </Popover>

            <Popover
                id={idMeetingDocs}
                open={openPopOverDocs}
                anchorEl={anchorElDocs}
                onClose={handleDocsClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: direction == "rtl" ? 'right' : 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: direction == "rtl" ? 'left' : 'right',
                }}

            >
                <Paper >
                    <div style={{
                        height: '100vh',
                        top: '0 !important',
                        //maxHeight: '100%'
                    }}>
                        <iframe
                            id="attachDocsIframe"
                            frameBorder='0'
                            style={{ display: selectedItems?.length === 0 ? 'initial' : 'none', width: '100%', height: '100%', borderRadius: ' 3.01px' }}
                            src={url} />

                    </div>
                </Paper>
            </Popover>


            <Popover
                id={idScheduleMeeting}
                open={openPopOverScheduleMeeting}
                anchorEl={anchorElScheduleMeeting}
                onClose={handleScheduleAMeetingClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: direction == "rtl" ? 'right' : 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: direction == "rtl" ? 'left' : 'right',
                }}
                PaperProps={{

                }}
            >
                <Paper>
                    <ScheduleMeeting inviteesList={inviteesList} setAnchorElScheduleMeeting={setAnchorElScheduleMeeting} handleScheduleClosee={handleScheduleClosee} />
                </Paper>
            </Popover>
        </ThemeProvider>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <DrawerHeader />
            {props.children}
        </Box>
    </Box>
    );
};
export default Layout;

interface ICategories {
    items: any[];
    id: string;
};

const styles = {
    parentFlexRight: {
        display: "flex",
        justifyContent: "flex-end"
    }
};
const ZoomMeetingDetails = () => {
    const zoomMeetingData = useSelector((state: ApplicationState) => state.appData?.meetingData);
    const appLanguage = useSelector((state: ApplicationState) => state.appData?.app4legalData?.lang);
    const direction = appLanguage == "ar" ? "rtl" : "ltr";
    const [alert, setAlert] = React.useState(false);
    const copyToClipboard = async () => {
        setAlert(true);
        const textField = document.getElementById('zoom_meeting_link') as HTMLElement;
        await copyTextToClipboard(zoomMeetingData?.join_url);
    };
    const copyToClipboardAll = async () => {
        setAlert(true);
        const textField = document.getElementById('zoom_meeting_details') as HTMLElement;
        await copyTextToClipboard(textField?.innerText + zoomMeetingData.join_url);
    };
    const handleClick = () => {
        setAlert(false);
    };
    return (
        <>  {alert ? <>
            <Snackbar open={alert} autoHideDuration={2000}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
                onClose={handleClick}>
                <Alert severity="success" sx={{ margin: "auto" }}>copied to clipboard</Alert>
            </Snackbar>
        </> : null}
            {zoomMeetingData ?
                <Card sx={{ minWidth: 100 }} dir={direction} >
                    <AppBar position="static">
                        <Toolbar>
                            <Typography
                                variant="h5"
                                noWrap
                                component="div"
                            >
                                {i18n.t('app.meetingInfo')}
                            </Typography>
                            <HelpOutlineIcon />
                        </Toolbar>
                    </AppBar>
                    <CardContent id="zoom_meeting_details" sx={{ paddingTop: '16px', paddingRight: '16px', paddingLeft: '16px', paddingBottom: '0px' }}>
                        <div>
                            <Typography sx={{ mb: 1.5 }} style={{ display: 'inline-block' }}>
                                <b>{i18n.t('app.title')} : &nbsp; </b>
                            </Typography>
                            <Typography component="div" style={{ display: 'inline-block' }}>
                                {zoomMeetingData.topic}
                            </Typography>
                        </div>
                        <div>
                            <Typography sx={{ mb: 1.5 }} style={{ display: 'inline-block' }}>
                                <b> {i18n.t('app.time')} : &nbsp;  </b>
                            </Typography>
                            <Typography style={{ display: 'inline-block' }}>
                                {moment(zoomMeetingData.start_time).format("MMM DD, YY")}  {zoomMeetingData.timezone ? zoomMeetingData.timezone.split("/")[0] : null}
                            </Typography>
                        </div>
                        <div>
                            <Typography sx={{ mb: 1.5 }} >
                                <b> {i18n.t('app.JoinZoomMeeting')}</b>
                            </Typography>
                            <Typography sx={{ mb: 1.5 }} style={{ display: 'inline-block' }}>
                                <small> <a href={zoomMeetingData.join_url} id="zoom_meeting_link"> {zoomMeetingData.join_url} </a></small>
                            </Typography>
                            <Typography sx={{ mb: 1.5 }} style={{ display: 'inline-block' }}>
                                <Button onClick={copyToClipboard} size="small" sx={{ ...styles.parentFlexRight }}> <Tooltip title="copy link" placement="top"><ContentCopyIcon fontSize="small" /></Tooltip></Button>

                            </Typography>
                            <Typography sx={{ ...styles.parentFlexRight/*,mb: 1.5*/ }}>
                                <Tooltip title="Copy Meeting Details" placement="top">
                                    <Button onClick={copyToClipboardAll} size="small" ><b> {i18n.t('app.copyAll')} </b></Button>
                                </Tooltip>
                            </Typography>
                        </div>
                    </CardContent>
                </Card>
                : <Stack p={2} direction="row"
                    spacing={2}>{i18n.t('app.noMeetStart')}</Stack>
            }
        </>
    );
};

export async function copyTextToClipboard(text: any) {
    if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
    } else {
        return document.execCommand('copy', true, text);
    }
};

function setAnchorElSchedule(arg0: null) {
    throw new Error('Function not implemented.');
}
